import React from "react"
import { Helmet } from "react-helmet"
import favicon from '../../static/favicon.ico'


const Seo = (props) => {
    return (
        <div className="seo">
            <Helmet>
                <meta charSet="utf-8" />

                <title>{`${props.pageMeta} - ${props.wpMeta.generalSettingsTitle}`}</title>
                <meta name="twitter:title" content={props.wpMeta.generalSettingsTitle} />
                <meta property="og:title" content={props.wpMeta.generalSettingsTitle} />

                <meta property="og:image" content={favicon} />
                <meta name="image" content={favicon} />
                <meta name="twitter:image" content={favicon} />

                <meta name="description" content={props.wpMeta.generalSettingsDescription} />
                <meta name="twitter:description" content={props.wpMeta.generalSettingsDescription} />
                <meta property="og:description" content={props.wpMeta.generalSettingsDescription} />

                <meta name="author" content="MRSolutions"></meta>
            </Helmet>
        </div>
    )
}
export default Seo